
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';


if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(n => preloaderFinished())
  .catch(err => console.error(err));

export function preloaderFinished() {
  setTimeout(() => {
    document.getElementsByClassName('preloader')[0].className = 'preloader-hidden';
  }, 200);
}


